__turbopack_context__.v({
  "input": "RoomInput-module-sass-module__eL5SCG__input" + " " + __turbopack_context__.i(91123)["input"] + " " + __turbopack_context__.i(41155)["pBold"],
  "inputWrapper": "RoomInput-module-sass-module__eL5SCG__inputWrapper",
  "label": "RoomInput-module-sass-module__eL5SCG__label",
  "shortcut": "RoomInput-module-sass-module__eL5SCG__shortcut",
});
